<app-spinner></app-spinner>
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 14px; color: #fff;">Carregando...</p>
</ngx-spinner>
<router-outlet></router-outlet>
